export default "__VITE_ASSET__5acd24f3__"